module.exports = __webpack_public_path__ + "img/facebook.9a5b06a4.svg";